<div *ngIf="enable != undefined">
  <ng-template *ngIf="enable; then enabled else disabled"></ng-template>
  <ng-template #enabled>
    <i class="bi bi-check-circle text-success opacity-75" title="{{enabledTitle}}"></i>
  </ng-template>
  <ng-template #disabled>
    <i class="bi bi-x-circle text-danger opacity-0" title="{{disabledTitle}}"></i>
  </ng-template>
</div>